import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import KHbase from '@/kanghe.config'
import SparkMD5 from '../../static/spark-md5'
// import { resolve } from 'dns';

const service = axios.create({
    baseURL: KHbase.url,
    timeout: 30000
})

const serviceO = axios.create({
    baseURL: KHbase.domain,
    timeout: 30000
})

let spark = new SparkMD5();

service.interceptors.request.use(config => {
    console.log('config', config);
    let timestamp = new Date().getTime();
    let salt = 'kanghehealth8888';
    let params = config.params || '';
    let postBody = config.data || '';
    let { url } = config;
    let urlQuery = url.split('?')[1] || '';
    let key = '';
    // console.log(options);
    if (params) { // !params传进来
        params = params && typeof params === 'string' ? params : JSON.stringify(params);
        params = params.replace(/[^a-zA-Z0-9{}]/g, '');
        params = params.replace(/\{|\}/g, '');
    } else { // !urlQuery传进来
        params = urlQuery.replace(/[^a-zA-Z0-9{}]/g, '');
    }
    // console.log(postBody, 'postBody');
    if (postBody) {
        postBody = postBody && typeof postBody === 'string' ? postBody : JSON.stringify(postBody);
        postBody = postBody.replace(/[^a-zA-Z0-9{}]/g, '');
    }
    key = params + postBody;
    // console.log('处理过的', key);
    let str = key + timestamp + salt;
    // console.log('加密字符', str)
    spark.append(str)
    let sign = spark.end();
    // let token = localStorage.getItem('user')
    let token = sessionStorage.getItem('user')
    if (token) {
        config.headers['X-Authorization'] = JSON.parse(token).jwtToken
    } else {
        config.headers['X-Authorization'] = 'no login'
    }

    config.headers['X-APP-ID'] = '2';
    config.headers['X-APP-VER'] = '1.0.0';
    config.headers['timestamp'] = timestamp;
    config.headers['sign'] = sign;
    if(config.method.toLocaleUpperCase() === 'GET' || config.method.toLocaleUpperCase() === 'DELETE'){
        config.params = {...config.params, ...config.data};
        delete config.data
    }
    return config
},function(err){
    return Promise.reject(err);
})

service.interceptors.response.use(response => {
    return new Promise((resolve,reject) => {
        // 处理服务端返回的状态码
        if (response.status === 200) {
            const responseBody = response.data
            if(responseBody.success){
                
            }else{
                let code = responseBody.code;
                if(code == "401"){
                    // localStorage.removeItem("user");
                    sessionStorage.removeItem("user");
                    localStorage.removeItem("name");
                    localStorage.removeItem("sex");
                    localStorage.removeItem('staffCode');
                    this.$router.push({ path: '/login/:channalId'})
                }
            }
            resolve(responseBody)
        }else{
            reject(responseBody);
        }
    })
},function(err){
    return Promise.reject(err)
})

serviceO.interceptors.request.use(config => {
    console.log('config', config);
    let timestamp = new Date().getTime();
    let salt = 'kanghehealth8888';
    let params = config.params || '';
    let postBody = config.data || '';
    let { url } = config;
    let urlQuery = url.split('?')[1] || '';
    let key = '';
    // console.log(options);
    if (params) { // !params传进来
        params = params && typeof params === 'string' ? params : JSON.stringify(params);
        params = params.replace(/[^a-zA-Z0-9{}]/g, '');
        params = params.replace(/\{|\}/g, '');
    } else { // !urlQuery传进来
        params = urlQuery.replace(/[^a-zA-Z0-9{}]/g, '');
    }
    // console.log(postBody, 'postBody');
    if (postBody) {
        postBody = postBody && typeof postBody === 'string' ? postBody : JSON.stringify(postBody);
        postBody = postBody.replace(/[^a-zA-Z0-9{}]/g, '');
    }
    key = params + postBody;
    console.log('处理过的', key);
    let str = key + timestamp + salt;
    console.log('加密字符', str)
    spark.append(str)
    let sign = spark.end();
    // let token = localStorage.getItem('user')
    let token = sessionStorage.getItem('user')
    if (token) {
        config.headers['X-Authorization'] = JSON.parse(token).jwtToken
    } else {
        config.headers['X-Authorization'] = 'no login'
    }
    // config.headers['X-APP-ID'] = '2';
    // config.headers['X-APP-VER'] = '1.0.0';
    config.headers['timestamp'] = timestamp;
    config.headers['sign'] = sign;
    if(config.method.toLocaleUpperCase() === 'GET' || config.method.toLocaleUpperCase() === 'DELETE'){
        config.params = {...config.params, ...config.data};
        delete config.data
    }
    return config
},function(err){
    return Promise.reject(err);
})

serviceO.interceptors.response.use(response => {
    return new Promise((resolve,reject) => {
        // 处理服务端返回的状态码
        if (response.status === 200) {
            const responseBody = response.data
            if(responseBody.success){
                
            }else{
                let code = responseBody.code;
                if(code == "401"){
                    // localStorage.removeItem("user");
                    sessionStorage.removeItem("user");
                    localStorage.removeItem("name");
                    localStorage.removeItem("sex");
                    localStorage.removeItem('staffCode');
                    this.$router.push({ path: '/login/:channalId'})
                }
            }
            resolve(responseBody)
        }else{
            reject(responseBody);
        }
    })
},function(err){
    return Promise.reject(err)
})

// export default service
export { service, serviceO };


// WEBPACK FOOTER //
// ./src/utils/axios.js